import { Component, Input, OnChanges, ViewEncapsulation, ChangeDetectionStrategy, SimpleChanges, ElementRef, ViewChild, Renderer2, HostListener, OnInit, Output, EventEmitter, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewportService } from 'src/app/services/viewport.service';
import { SwiperModule, SwiperComponent } from 'swiper/angular';
import { ButtonModule } from 'primeng/button';
import { Item } from 'src/app/models/liveshop';
import { VideoModalService } from 'src/app/services/video-modal.service';
import { Subscription } from 'rxjs';

interface VideoItem {
  uid: string;
  id: number;
  src: string;   // URL do vídeo
  poster: string; // Poster do vídeo
  thumbnail?: string;
  title?: string;
  isLoading?: boolean;
}
@Component({
  selector: 'app-stories',
  standalone: true,
  templateUrl: './stories.component.html',
  styleUrls: ['./stories.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, SwiperModule, ButtonModule],
  encapsulation: ViewEncapsulation.Emulated
})
export class StoriesComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() arraySlicksFull: Item[] = [];
  @Input() videoUrls: VideoItem[] = [];
  @Input() posterUrls: string[] = [];
  @Input() height: number | undefined;
  @Input() templateType: string | undefined;
  @Input() loadingComplete!: EventEmitter<void>;
  @Input() containerDiv?: ElementRef<HTMLDivElement>;
  @Input() pageToVideos: number = 0;
  @Input() widget_id?: number | undefined;
  @Input() totalAssets: number = 0;
  @Input() store_id?: number | undefined;
  @Input() template_id?: number | undefined;
  @Input() aspectRatio?: any;
  @Input() instanceId?: string;
  @Output() loadMoreVideos = new EventEmitter<void>();
  @Output() openSidebar = new EventEmitter<void>();
  @ViewChild(SwiperComponent) swiperComponent!: SwiperComponent;
  @Input() isAdmin: boolean = true;
  @Output() modalOpened = new EventEmitter<VideoItem>();

  slidesPerView: number = 1;
  containerClass: string = 'col-12';

  swiperKey: number = 0;  // Chave para forçar a recriação do Swiper

  // Controla a visibilidade das setas de navegação: o próprio Swiper (watchOverflow,
  // ligado no template) sabe se os slides cabem todos na área visível ou não —
  // "lock"/"unlock" disparam quando esse estado muda (inclusive em resize).
  isSwiperLocked = false;
  onSwiperLock(): void {
    this.isSwiperLocked = true;
    this.cdr.markForCheck();
  }
  onSwiperUnlock(): void {
    this.isSwiperLocked = false;
    this.cdr.markForCheck();
  }

  private modalStateSub?: Subscription;
  private loadingCompleteSubscription?: Subscription;
  private resizeObserver?: ResizeObserver;
  private currentlyOpenUid?: string;

  constructor(
    private cdr: ChangeDetectorRef,
    private viewportService: ViewportService,
    private host: ElementRef,
    private renderer: Renderer2,
    private videoModalService: VideoModalService
  ) {
    this.modalStateSub = this.videoModalService.state$
      .subscribe((state) => {
        if (state.instanceId && this.instanceId && state.instanceId !== this.instanceId) {
          return;
        }
        if (!state.show) {
        this.currentlyOpenUid = undefined;
        }
      });
  }
  ngOnInit(): void {

    this.updateSlidesPerView(window.innerWidth);

    // Assinando o evento `loadingComplete` para remover o item temporário assim que o carregamento é concluído
    if (this.loadingComplete) {
      this.loadingCompleteSubscription = this.loadingComplete.subscribe(() => {
        this.removeLoadingIndicator();
      });
    }

    if (this.containerDiv) {
      this.updateSlidesPerView(this.containerDiv.nativeElement.offsetWidth);
    }
  }
  itemClass = 'col-12-item';
  itemWidth: string = '200px';
  ngAfterViewInit(): void {
    if (this.containerDiv && this.containerDiv.nativeElement) {
      this.resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const newWidth = entry.contentRect.width;
          this.itemClass = newWidth < 1024 ? 'col-4-item' : 'col-12-item';
          this.itemWidth = newWidth < 1024 ? `${newWidth}px` : '200px';
          this.updateSlidesPerView(newWidth); // Certifique-se de que este método é chamado aqui
          this.cdr.detectChanges();
        }
      });
      this.resizeObserver.observe(this.containerDiv.nativeElement);
    }

    this.viewportService.setTemplateType(this.templateType);
  }

  openModal(video: VideoItem) {
    if (this.currentlyOpenUid === video.uid) {
      return;
    }
    this.currentlyOpenUid = video.uid;
    void this.videoModalService.open({
      video,
      slicks: this.arraySlicksFull,
      totalAssets: this.totalAssets,
      isAdmin: this.isAdmin,
      widgetId: this.widget_id,
      storeId: this.store_id,
      templateId: this.template_id,
      height: this.height,
      pageToVideos: this.pageToVideos,
      instanceId: this.instanceId
    });
    this.modalOpened.emit(video);
  }


  trackByFn(index: number, item: VideoItem): any {
    return item.uid; // Podemos usar `item.uid` ou qualquer propriedade única para identificar o item
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['aspectRatio']) {
    }
    if (changes['store_id']) {
    }
    if (changes['template_id']) {
    }
    if (changes['totalAssets']) {
    }
    if (changes['widget_id']) {
    }
    if (changes['arraySlicksFull']) {
    }
    if (changes['videoUrls']) {
      // Verifica se o `videoUrls` foi atualizado com novos vídeos
      this.removeLoadingIndicator(); // Remove o spinner de carregamento se houver vídeos novos
    }
    if (changes['loadingComplete'] && this.loadingComplete) {
      // Assina o evento `loadingComplete` para remover o indicador de carregamento
      this.removeLoadingIndicator();
    }
    if (changes['pageToVideos']) {
    }
  }

  // Função para emitir o evento quando o botão for clicado
  onOpenSidebar(): void {
    this.openSidebar.emit();
  }
  spaceBetween: number = 20;
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    if (this.containerDiv && this.containerDiv.nativeElement) {
      const newWidth = this.containerDiv.nativeElement.offsetWidth; // Usa a largura do containerDiv
      this.updateSlidesPerView(newWidth); // Passa a largura do containerDiv
    }
  }
  updateSlidesPerView(containerWidth: number): void {
    this.spaceBetween = 10;
    this.cdr.detectChanges(); // Atualiza o layout

    // Aguarda o Swiper atualizar o layout antes de definir a largura do slide
    const swiperRef = this.swiperComponent?.swiperRef;

    // Verifique se o swiperRef e slides existem e possuem elementos
    if (swiperRef?.slides && swiperRef.slides.length > 0) {
      const firstSlide = swiperRef.slides[0] as HTMLElement;
      const slideWidth = firstSlide.offsetWidth;

      // Define a largura do slide na variável CSS
      const swiperElement = swiperRef.el;
      if (swiperElement) {
        // eslint-disable-next-line no-restricted-syntax
        swiperElement.style.setProperty('--slide-width', `${slideWidth}px`);
      }
    }
    this.cdr.detectChanges();
  }







  // Método para verificar se estamos no penúltimo slide e carregar mais vídeos
  onSwiperActiveIndexChange(): void {
    const slides = document.querySelectorAll('.swiper-slide');
    const activeIndex = this.swiperComponent?.swiperRef?.activeIndex ?? -1;

    // Calcule o número atual de slides visíveis
    const swiperWidth = this.swiperComponent?.swiperRef?.width ?? 1; // largura da área de visualização do Swiper
    const slideWidth = slides[0]?.clientWidth ?? swiperWidth; // largura de um slide (ou largura da área se não houver slides)

    const currentSlidesPerView = Math.floor(swiperWidth / slideWidth); // número estimado de slides visíveis

    // Ajustar o cálculo para disparar o evento de carregar mais vídeos, considerando slides visíveis atuais
    if (activeIndex >= slides.length - currentSlidesPerView - 1 && this.totalAssets > slides.length) {
      this.addLoadingIndicator();
      this.loadMoreVideos.emit();
    }
  }

  isLoading: boolean = false;
  // Método para adicionar o item temporário com o spinner
  addLoadingIndicator(): void {
    if (!this.isLoading) {
      this.isLoading = true;
      this.videoUrls = [...this.videoUrls, { uid: 'loading', id: -1, src: '', poster: '', isLoading: true }];
      this.cdr.detectChanges();
    }
  }
  // Método para remover o item temporário com o spinner
  removeLoadingIndicator(): void {
    this.isLoading = false;
    this.videoUrls = this.videoUrls.filter(video => !video.isLoading);
    this.cdr.detectChanges();
  }
  addNewVideos(newVideos: VideoItem[]): void {
    if (newVideos.length > 0) {
      // Adiciona os novos vídeos ao array atual
      this.videoUrls = [...this.videoUrls, ...newVideos];
      // Forçar a detecção de mudanças para que o Swiper reconheça o novo conteúdo
      this.cdr.detectChanges();

      // Atualizar a chave do swiper para forçar a recriação do componente (se necessário)
      this.swiperKey++;
    }
  }



  isDragging = false;
  touchStartX = 0;
  touchStartY = 0;
  dragThreshold = 10; // Distância mínima para considerar arrasto
  touchStartTime = 0;

  onTouchStart(event: TouchEvent) {
    this.isDragging = false;
    this.touchStartX = event.touches[0].clientX;
    this.touchStartY = event.touches[0].clientY;
    this.touchStartTime = Date.now();
  }

  onTouchMove(event: TouchEvent) {
    const deltaX = Math.abs(event.touches[0].clientX - this.touchStartX);
    const deltaY = Math.abs(event.touches[0].clientY - this.touchStartY);

    if (deltaX > this.dragThreshold || deltaY > this.dragThreshold) {
      this.isDragging = true;
    }
  }

  onTouchEnd(video: VideoItem) {
    const touchDuration = Date.now() - this.touchStartTime;

    if (!this.isDragging && touchDuration < 200) {
      this.openModal(video);
    }

    this.isDragging = false;
  }

  // Para Desktop - Mesmo conceito com eventos do mouse
  mouseStartX = 0;
  mouseStartY = 0;

  onMouseDown(event: MouseEvent) {
    this.isDragging = false;
    this.mouseStartX = event.clientX;
    this.mouseStartY = event.clientY;
  }

  onMouseMove(event: MouseEvent) {
    const deltaX = Math.abs(event.clientX - this.mouseStartX);
    const deltaY = Math.abs(event.clientY - this.mouseStartY);

    if (deltaX > this.dragThreshold || deltaY > this.dragThreshold) {
      this.isDragging = true;
    }
  }

  onMouseUp(video: VideoItem) {
    if (!this.isDragging) {
      this.openModal(video);
    }
    this.isDragging = false;
  }


  @ViewChild('swiper', { static: false }) swiperCarouselRef?: SwiperComponent;

  get swiperInstanceCarousel() {
    return this.swiperCarouselRef?.swiperRef;
  }

  ngOnDestroy(): void {
    this.modalStateSub?.unsubscribe();
    this.loadingCompleteSubscription?.unsubscribe();
    this.resizeObserver?.disconnect();
  }
}

